<div NgxLoadingXBlur class="background">
  <div class="contain">
    <img class="image" src="/assets/images/LOGO-55.png">
    <div class="text-container">
      <h1 class="text-center title">Despacho</h1>
      <h1 class="text-center text">Iniciar Sesión</h1>
    </div>

    <mat-card>
      <mat-card-content>
        <form novalidate [formGroup]="loginForm" #lform="ngForm" (ngSubmit)="login()">
          <mat-form-field class="full-width-input">
            <mat-label class="text-field">Correo electrónico</mat-label>
            <input matInput formControlName="email" type="text" name="email" required autocomplete="on">
            <mat-icon matSuffix>alternate_email</mat-icon>
            <mat-error *ngIf="formErrors.email">{{formErrors.email}}</mat-error>
          </mat-form-field>
          <mat-form-field class="full-width-input mt-2">
            <mat-label class="text-field">Contraseña</mat-label>
            <input matInput formControlName="password" required [type]="!passwordIsActive ? 'password': 'text'"
              name="password" autocomplete="off">
            <mat-icon class="icon-cursor" matSuffix (click)="passwordIsActive = !passwordIsActive"
              matTooltip="{{ !passwordIsActive ? 'Mostrar contraseña' : 'Ocultar contraseña'}}">
              {{ !passwordIsActive ? 'visibility_off': 'visibility' }}
            </mat-icon>
            <mat-error *ngIf="formErrors.password">{{formErrors.password}}</mat-error>
          </mat-form-field>
          <div class="form-group">
            <button mat-raised-button class="btn-login" type="submit" [disabled]="loginForm.invalid">Entrar</button>
          </div>
        </form>
      </mat-card-content>
      <a mat-list-item class="forgot-password" (click)="openDialog()"><b><u>OLVIDÉ MI
            CONTRASEÑA</u></b></a>
      <p class="version">version {{VERSION}}</p>
    </mat-card>
  </div>
</div>
<ngx-loading-x [show]="isLoading"></ngx-loading-x>